exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".explore{display:flex;height:100%;overflow:hidden;flex-grow:1;flex-direction:column}.explore h1{padding-top:64px}.explore .content{display:flex;overflow:hidden;flex-grow:1;flex-direction:row}.ReactModal__Overlay.ReactModal__Overlay--after-open{z-index:3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/routes/group-students/style.scss
// module id = 289
// module chunks = 0